var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestInPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FA7700"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.403 0L.13 10.27H.04v.143L0 10.481l.041.024V45h49.883V10.525L50 10.48l-.076-.124v-.087h-.053L43.596 0H6.403zm1.304 2.246h34.586l4.902 8.024H2.805l4.902-8.024zM2.338 42.754h45.29V12.516H2.337v30.238z",
    transform: "translate(-163 -904) translate(163 904)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.642 35.574L27.234 37.241 37.5 27.932 27.234 18.621 25.642 20.288 32.815 26.792 10.938 26.792 10.938 29.068 32.819 29.068z",
    transform: "translate(-163 -904) translate(163 904)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestInPost);
export default __webpack_public_path__ + "static/media/test-in-post.7dbf5bad.svg";
export { ForwardRef as ReactComponent };